import { Typography } from "@mui/material";
import { CHIPS_COLOR, Student } from "../../types/students";
import { User } from "../../types/users";
import KanbanColumnShell from "../common/KanbanColumnShell";
import KanbanCard from "./KanbanCard";

interface Props {
  status: string;
  students: Student[];
  users: User[];
  onDragStart: (id: string) => void;
  onDrop: (status: string) => void;
  onCardClick: (student: Student) => void;
}

function KanbanColumn({ status, students, users, onDragStart, onDrop, onCardClick }: Props) {
  const totalCommission = students.reduce(
    (sum, s) => sum + (Number((s as any).commission) || 0),
    0
  );

  return (
    <KanbanColumnShell
      status={status}
      chipColor={(CHIPS_COLOR[status] as any) ?? "default"}
      count={students.length}
      width={220}
      onDrop={() => onDrop(status)}
      headerExtra={
        totalCommission > 0 ? (
          <Typography variant="caption" sx={{ color: "#059669", fontSize: "0.62rem", fontWeight: 600 }}>
            RM {totalCommission.toLocaleString()}
          </Typography>
        ) : undefined
      }
    >
      {students.map((student) => (
        <KanbanCard
          key={student._id}
          student={student}
          users={users}
          onDragStart={onDragStart}
          onClick={onCardClick}
        />
      ))}
    </KanbanColumnShell>
  );
}

export default KanbanColumn;
